﻿'use strict';

angular.module('ntmApp')
  .filter('format', function () {

      return function (input, formatPattern) {
          return formatPattern.format(input);
      };
  });